import React from "react";
import styles from "@components/MarketVisitReport/MarketVisitReport.module.css";

/**
 * ProductSection Component
 * Product quality and feedback section of Market Visit Report
 */
const ProductSection = ({
  formData,
  onChange,
  characterLimitValidation,
  formValidation,
  disable,
}) => {
  return (
    <>
      {/* Section Header */}
      <div className={`row m-0 ${styles.MarketVisitReport__headingBox}`}>
        <div className={`col-8 p-0 ${styles.MarketVisitReport__heading}`}>
          Product
        </div>
      </div>

      {/* productQuality field is intentionally hidden (matches production) */}
      {characterLimitValidation?.productQuality && (
        <p className={styles.MarketVisitReport__validationErrors}>
          {characterLimitValidation?.productQuality}
        </p>
      )}

      <div className={styles.MarketVisitReport__selectableRows}>
        <div className={styles.MarketVisitReport__selectableRows}>
          <label className={styles.MarketVisitReport__selectLabel}>
            New Products/Application/Surface related opportunities identified:
          </label>
          <textarea
            name="newProductOpportunity"
            value={formData?.newProductOpportunity}
            rows="3"
            className={` ${styles.MarketVisitRepor__textArea}`}
            style={{ paddingLeft: "8px" }}
            onChange={(e) => onChange(e)}
            disabled={disable}
            maxLength={501}
          />
          {characterLimitValidation?.newProductOpportunity && (
            <p className={styles.MarketVisitReport__validationErrors}>
              {characterLimitValidation?.newProductOpportunity}
            </p>
          )}
          {!formData?.newProductOpportunity &&
            formValidation?.newProductOpportunity && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {formValidation?.newProductOpportunity}
              </p>
            )}
        </div>

        <div className={styles.MarketVisitReport__selectableRows}>
          <label className={styles.MarketVisitReport__selectLabel}>
            Other product/packaging related feedback:
          </label>
          <textarea
            name="productOtherFeedback"
            value={formData?.productOtherFeedback}
            rows="3"
            className={` ${styles.MarketVisitRepor__textArea}`}
            style={{ paddingLeft: "8px" }}
            onChange={(e) => onChange(e)}
            disabled={disable}
            maxLength={501}
          />
          {characterLimitValidation?.productOtherFeedback && (
            <p className={styles.MarketVisitReport__validationErrors}>
              {characterLimitValidation?.productOtherFeedback}
            </p>
          )}
          {!formData?.productOtherFeedback &&
            formValidation?.productOtherFeedback && (
              <p className={styles.MarketVisitReport__validationErrors}>
                {formValidation?.productOtherFeedback}
              </p>
            )}
        </div>

        <div className={styles.MarketVisitReport__footnote}>
          <p>
            In case of any product-related complaint, please raise a{" "}
            <a href="/PCMS" className={styles.MarketVisitReport__inlineLink}>
              PCMS
            </a>{" "}
            request.
          </p>
          <p>
            In case of any counterfeit or duplicate product found in the market,
            please report the same via this{" "}
            <a
              href="https://pidilitecwp.my.salesforce-sites.com/brandprotectionsurveyform"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.MarketVisitReport__inlineLink}
            >
              Brand Protection Survey
            </a>
            .
          </p>
        </div>
      </div>
    </>
  );
};

export default ProductSection;
